function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[^\w\u00C0-\u024f]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

document.addEventListener("DOMContentLoaded", function () {
  // Declarations.
  const scopingClassName = "product-landing-section.desk";

  // Initially selected variant options.
  var selectedColorName = document.querySelector(
    `.${scopingClassName} input[name="color"]:checked`
  ).value;
  var selectedTableTopValue = document.querySelector(
    `.${scopingClassName} input[name="table-top"]:checked`
  ).value;
  var selectedVariantPriceCntnr = document.querySelector(
    `.${scopingClassName} .price-container.active`
  );
  var selectedVariantId = document.querySelector(
    `.${scopingClassName} .price-container.active`
  ).dataset["variantId"];
  const modulusCtaBtn = document.querySelectorAll(
    ".modulus-cta"
  );

  // Elems.
  const ctaBtn = document.querySelector(
    `.${scopingClassName} .add-to-cart-container .cta-btn`
  );
  const ctaBtnDot = document.querySelector(
    ".add-to-cart-container .cta-under .product-avail-dot"
  );
  const ctaBtnText = document.querySelector(
    ".add-to-cart-container .cta-under .product-avail-text"
  );
  const notifyMeBtn = document.querySelector(
    ".add-to-cart-container .sub-container2 .add-to-cart-notify"
  );
  const addToCardWhatsappBtn = document.querySelector(
    ".shop-on-call-icons"
  );
  const addToCardWhatsappBtnMobile = document.querySelector(
    ".shop-on-call-icons-mobile"
  );
  const ctaBtnLinkText = document.querySelector(
    ".add-to-cart-container .sub-container2 .whatsapp-text"
  );
  const eddElem = document.querySelector(
    ".edd-or-preorder-container .edd-container"
  );
  const preorderBannerElem = document.querySelector(
    ".edd-or-preorder-container pre-order-banner"
  );

  /* Offer carausel */
  const  offer_price =  document.querySelector(
    ".offer-carousel .offer-carousel-container .card .body.offer span"
  )
  
  // Derived.
  var selectedVariantTitle = `${selectedColorName} / ${selectedTableTopValue}`;
  var handleizedSelectedVariantTitle = handleize(selectedVariantTitle);

  // product detail ships today/tomorrow
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinutes = now.getMinutes();

  // onload logic for ships today/tomorrow
  // ships today/tomorrow shows when varient is available and is nnot preorder
  if(selectedVariantPriceCntnr.dataset["variantAvailable"] != "false" && (selectedVariantPriceCntnr.dataset["variantPreorder"] == "false" || selectedVariantPriceCntnr.dataset["variantPreorder"] == "")){
    if (currentHour < 13 || (currentHour === 13 && currentMinutes < 30)) {
      ctaBtnText.innerHTML = "Ships today";
    } else {
      ctaBtnText.innerHTML = "Ships tomorrow";
    }
  }

  // Attach change handlers to color and table top options.
  document
    .querySelectorAll(`.${scopingClassName} input[name="color"]`)
    .forEach((inputElem) => {
      inputElem.addEventListener("change", handleColorChange);
    });
  document
    .querySelectorAll(`.${scopingClassName} input[name="table-top"]`)
    .forEach((inputElem) => {
      inputElem.addEventListener("change", handleTableTopSizeChange);
    });

  // Handler for color change.
  function handleColorChange(e) {
    selectedColorName = e.target.value;
    updateDerivedString();
    changeProductImage();
    changePriceContainer();
  }

  // Handler for table top size change.
  function handleTableTopSizeChange(e) {
    selectedTableTopValue = e.target.value;

    // Update derived strings.
    updateDerivedString();

    // Update component's visibility. Show new. Hide old.
    changeProductImage();
    changePriceContainer();
  }

  /** Run this before changing the state of DOM. */
  function updateDerivedString() {
    selectedVariantTitle = `${selectedColorName} / ${selectedTableTopValue}`;
    handleizedSelectedVariantTitle = handleize(selectedVariantTitle);
    console.log(selectedVariantTitle);
  }

  /** Depends on updateDerivedString to be run before this. */
  function changeProductImage() {
    const curMediaContainer = document.querySelector(
      `.${scopingClassName} .media-container.active`
    );
    curMediaContainer.classList.remove("active");

    const newMediaContainer = document.querySelector(
      `.${scopingClassName} .media-container.${handleizedSelectedVariantTitle}`
    );
    newMediaContainer.classList.add("active");
  }

  /** Depends on updateDerivedString to be run before this.
   * Updates Prices, CTA text, and styles based on variant availability.
   **/
  function resetCTA(){
    ctaBtn.classList.remove("sold-out");
    ctaBtn.style.pointerEvents = "unset";
    ctaBtn.textContent = "";
    ctaBtnDot.classList.remove("dot-red");
    ctaBtnText.textContent = "";
    ctaBtnLinkText.textContent = "";
    notifyMeBtn.classList.add("hide");
    addToCardWhatsappBtn.classList.add("hide");
    addToCardWhatsappBtnMobile.classList.add("hide");  
  }

  function addToCardCTA(){
    ctaBtn.textContent = "Add to cart";
    if(currentHour < 13 || (currentHour === 13 && currentMinutes < 30))ctaBtnText.textContent = "Ships today";
    else ctaBtnText.textContent = "Ships tomorrow";
    ctaBtnLinkText.textContent = "Shop on call";
    addToCardWhatsappBtnMobile.classList.remove("hide");
    addToCardWhatsappBtn.classList.remove("hide");
    // Update EDD-or-Preorder container.
    preorderBannerElem.classList.add("hide");
    eddElem.classList.remove("hide");
  }

  function preOrderCTA(newPriceContainer){
    ctaBtn.textContent = "Pre-order*";
    ctaBtnDot.classList.add("dot-red");
    ctaBtnText.textContent = "Shipping starts on 10 April 2025";
    ctaBtnLinkText.textContent = "";
    const offerPrice = newPriceContainer.dataset["variantPreorderOfferPrice"];
    const salePrice = newPriceContainer.dataset["variantPreorderCompareAtSalePrice"];
    preorderBannerElem.setAttribute('price', offerPrice);
    preorderBannerElem.setAttribute('compare-at-sale-price', salePrice);
    preorderBannerElem.classList.remove("hide");
    eddElem.classList.add("hide");
  }

  function notifyMeCTA(){
    ctaBtn.classList.add("sold-out");
    ctaBtn.style.pointerEvents = "none";
    ctaBtn.textContent = "Add to cart";
    ctaBtnDot.classList.add("dot-red");
    ctaBtnText.textContent = "Sold out";
    ctaBtnLinkText.textContent = "Notify me";
    notifyMeBtn.classList.remove("hide");
    // Update EDD-or-Preorder container.
    preorderBannerElem.classList.add("hide");
    eddElem.classList.remove("hide");
  }

  function changePriceContainer() {
    const curPriceContainer = document.querySelector(
      `.${scopingClassName} .price-container.active`
    );
    curPriceContainer.classList.remove("active");

    const newPriceContainer = document.querySelector(
      `.${scopingClassName} .price-container.${handleizedSelectedVariantTitle}`
    );
    newPriceContainer.classList.add("active");
    selectedVariantId = newPriceContainer.dataset["variantId"];

    // Update CTA btn, based on variant availability.
    const available = newPriceContainer.dataset["variantAvailable"];
    const preOrder = newPriceContainer.dataset["variantPreorder"]
    resetCTA();
    if (available === "false") {
      notifyMeCTA();   
    } else if(preOrder == "true"){
      preOrderCTA(newPriceContainer);
    }else{
      addToCardCTA();
    }
  }

  // TODO: Scroll to explore should be a reusable component.
  /* Initialize Explore indicator functionality. */
  // It should hide itself is user scrolls certain pixels.
  if (!isMobileDevice) {
    const exploreIndicatorElem = document.getElementById("explore-indicator"); // Replace with your element's ID
    const bentoLayout = document.getElementById("bento-layout"); // Replace with your element's ID
    const scrollThreshold = 200; // Adjust the scroll threshold as needed

    window.addEventListener("scroll", () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition >= scrollThreshold) {
        exploreIndicatorElem.style.display = "none";
      } else {
        exploreIndicatorElem.style.display = "flex";
      }
    });
    exploreIndicatorElem.addEventListener("click", () => {
      bentoLayout.scrollIntoView({ behavior: "smooth" });
      exploreIndicatorElem.style.display = "none";
    });
  }

  /** Add product to cart */
  const addToCartBtn = document.querySelector(
    ".add-to-cart-container .cta-btn"
  );
  addToCartBtn.addEventListener("click", addVariantToCart);

  async function addVariantToCart() {
    await Shopify.addVariantToCart(selectedVariantId);
    Shopify.eventBus.emit("add-variant-to-cart");
  }

  
  // modulus
  async function isModulusAvailable(){
    if(modulusCtaBtn[0].classList.contains("disabled"))return;
    const url = 'https://pkhwnphzllnyptnvqxsi.supabase.co/functions/v1/agent-status';
    const token = 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBraHducGh6bGxueXB0bnZxeHNpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzcwNDk4NTksImV4cCI6MjA1MjYyNTg1OX0.0GW5GLqzeiMtL6tUpn-khkRSRJBH1rp6yVZn4nqD2CY';
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': token,
            },
            body: JSON.stringify({ "name": 'Functions' })
        });
        
        const data = await response.json();
        if(data.is_available){
          modulusCtaBtn.forEach((btn) => {
            btn.href = "https://modulus-client-app-web.vercel.app/"
            btn.target = "_blank";
          });
          return;
        }
    } catch (error) {
        console.error('Error:', error);
    }
    modulusCtaBtn.forEach((btn) => {
      btn.classList.add("disabled");
    });
  }

  isModulusAvailable();
  changePriceContainer();
});
